import qs from 'qs'

export const getQueryParams = <ObjectType extends object>(obj: ObjectType) => qs.stringify(obj, { arrayFormat: 'brackets' })